<template>
  <BaseModal modalColor="border-success bg-primary" iconModal="fa fa-edit" subtitulo="Cadastrar novo material da etapa"
             col-md="col-md-5" offset="3">
    <template v-slot:modalContent>
      <form ref="cadastroForm" @submit.prevent="submitIncluirForm">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label><strong>Modelo Etapa: </strong></label>
              <p class="font-bold">{{ modeloEtapa }}</p>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.material"
                    inputId="material"
                    :options="materiais"
                    optionLabel="descricao"
                    optionValue="id"
                    size="small"
                    appendTo="body"
                    filter
                    style="width: 100%"
                    :invalid="campoVazio.includes('material')"
                >
                  <template #emptyfilter>
                    Nenhum resultado encontrado
                  </template>
                </Select>
                <label for="material">
                  <strong>Material:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="unidade" v-model="dado.unidade" size="small" style="width: 100%"
                           title="Unidade de Medida"
                           :invalid="campoVazio.includes('unidade')"/>
                <label for="unidade"><strong>Medida: <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="quantidade" v-model="dado.quantidade" size="small" style="width: 100%"
                             fluid :inputStyle="{ textAlign: 'right' }"
                             :invalid="campoVazio.includes('quantidade')"/>
                <label for="quantidade"><strong>Quantidade: <span
                    class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="valor_unitario" v-model="dado.valor_unitario" size="small" style="width: 100%"
                             title="Valor da unidade" :invalid="campoVazio.includes('valor_unitario')"
                             @blur="valorTotal"
                             :minFractionDigits="2" :maxFractionDigits="5" fluid :inputStyle="{ textAlign: 'right' }"/>
                <label for="valor_unitario"><strong>Valor Uni(R$): <span
                    class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="valor_total" v-model="dado.valor_total" size="small" style="width: 100%"
                             title="Valor Total" :minFractionDigits="2" :maxFractionDigits="5" fluid
                             :inputStyle="{ textAlign: 'right' }" disabled/>
                <label for="valor_total"><strong>Valor Total(R$): <span
                    class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="fechar">
            Cancelar
          </button>
        </div>
      </form>
      <hr>
      <!-- Compras Itens -->
      <label><strong>Itens da Compra:</strong></label>

      <div class="table-responsive">
        <table id="table_list" class="table table-striped table-bordered table-hover dataTables-example">
          <thead>
          <tr>
            <th>ID</th>
            <th>MODELO ETAPA</th>
            <th>MATERIAL</th>
            <th>UNID</th>
            <th>QTD</th>
            <th>VALOR UNI(R$)</th>
            <th>VALOR TOTAL(R$)</th>
            <th class="text-center">+</th>
          </tr>
          </thead>
          <tbody class="overflow-auto" style="max-height: 300px">
          <tr v-for="item in dados" :key="item.id" :id="'linha_' + item.key">
            <td class="text-right">{{ item.id }}</td>
            <td v-if="item.modelo_etapa_descricao">{{ item.modelo_etapa_descricao }}</td>
            <td v-else>{{ item.modelo_etapa_exibicao }}</td>
            <td v-if="item.material_descricao">{{ item.material_descricao }}</td>
            <td v-else>{{ item.material }}</td>
            <td class="text-right">{{ item.unidade }}</td>
            <td class="text-right">{{ item.quantidade }}</td>
            <td class="text-right">{{ item.valor_unitario }}</td>
            <td class="text-right font-bold">{{ item.valor_total }}</td>
            <td class="text-center">
              <button class="btn btn-danger btn-xs" @click="deletarModeloMaterial(item.key, item.id, item.material)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest, alertDelete} from "../../../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";

export default {
  name: "CadastrarModeloMaterial",
  components: {
    BaseModal,
  },
  props: {
    modeloEtapaId: Number,
    modeloEtapa: String,
  },
  emits: ["fechar", "atualizarLista"],
  data() {
    return {
      materiais: [],
      dados: [],
      dado: {
        modelo_etapa: this.modeloEtapaId,
        modelo_etapa_descricao: "",
        material_descricao: "",
        material: "",
        unidade: "",
        quantidade: "",
        valor_unitario: "",
        valor_total: "",
      },
      campoVazio: [],
    }
  },
  methods: {
    valorTotal() {
      const qtd = parseFloat(this.dado.quantidade) || 0;
      const valorUnitario = parseFloat(this.dado.valor_unitario) || 0;

      this.dado.valor_total = qtd * valorUnitario;
    },
    fechar() {
      this.$emit("fechar");
    },
    deletarModeloMaterial(modeloMaterialkey, modeloMaterialId, modeloMaterialNome) {
      let url = apiUrl.modelos.materialDestroy(modeloMaterialkey);
      alertDelete(modeloMaterialkey, url, 'Você deseja deletar o registro?', `ID: ${modeloMaterialId} | ${modeloMaterialNome}`,

        () => {
            this.$emit("atualizarLista");
        });
    },
    async getMateriais() {
      const resultado = await apiRequest("GET", `${apiUrl.materiais.createList}?status=A`);
      if (resultado.success) {
        this.materiais = resultado.data.results;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getModeloMateriais() {
      const resultado = await apiRequest("GET", `${apiUrl.modelos.materialCreateList}?modelo_etapa_id=${this.modeloEtapaId}`);
      if (resultado.success) {
        this.dados = resultado.data;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitIncluirForm() {
      const resultado = await apiRequest("POST", apiUrl.modelos.materialCreateList, this.dado);
      if (resultado.success) {
        this.dados.push(resultado.data);
        this.$emit('atualizarLista');
        this.$toastMessage("success", "Registro salvo com sucesso!");
        this.dado = {
          modelo_etapa: this.modeloEtapaId,
          modelo_etapa_descricao: "",
          material_descricao: "",
          material: "",
          unidade: "",
          quantidade: "",
          valor_unitario: "",
          valor_total: "",
        };
      } else {
        this.campoVazio = Object.keys(resultado.error);
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  created() {
    this.getMateriais();
    this.getModeloMateriais();
  }
}
</script>
